import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { AffCodeType } from 'src/app/affcode/shared/affcode-type.model';
import { AffCodeService } from 'src/app/affcode/shared/affcode.service';
import { AffiliationCodeMetadataLego } from '../../shared/dto/affiliation-code-metadata.lego';
import { Optional, SkipSelf } from '@angular/core';

@Component({
  selector: 'wl-affiliation-code-lego-edit',
  templateUrl: './affiliation-code-lego-edit.component.html',
  styleUrls: ['./affiliation-code-lego-edit.component.less'],
  viewProviders: [
  {
    provide: ControlContainer,
    useFactory: (container: ControlContainer) => container,
    deps: [[new Optional(), new SkipSelf(), ControlContainer]]
  }],
    standalone: false
})
export class AffiliationCodeLegoEditComponent implements OnInit, OnChanges {
  @Input() affiliationCodeData: AffiliationCodeMetadataLego;
  allAffCodeTypes: Array<AffCodeType>;
  affCodeTypes: Array<SelectItem>;
  affCodes: Array<SelectItem>;
  affCodeTypeId = 0;

  constructor(private _affCodeService: AffCodeService) {}

  ngOnInit(): void {
    this._affCodeService.getAllAffCodeTypesAndAffCodes().then((data) => {
      this.allAffCodeTypes = data.filter((x) => x.AffCodeType != '');
      this.affCodeTypes = this.allAffCodeTypes.map((x) => {
        return { value: x.AffCodeTypeID, label: x.AffCodeType } as SelectItem;
      });
      if (this.affiliationCodeData?.AffCode) {
        this.setAffType();
      }
    });
  }

  affCodeTypeChanged(affCodeTypeId: number) {
    this.setAffCodeOptions();
  }

  affCodeChanged(affCode: string) {
    let descr = this.allAffCodeTypes
      .find((x) => x.AffCodes.some((ac) => ac.AffCode == affCode))
      .AffCodes.find((x) => x.AffCode == affCode)?.Descr;
    this.affiliationCodeData.Label = descr;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.affiliationCode) {
      this.setAffType();
    }
  }

  private setAffType() {
    this.affCodeTypeId = this.allAffCodeTypes.find((x) =>
      x.AffCodes.some((ac) => ac.AffCode == this.affiliationCodeData.AffCode)
    )?.AffCodeTypeID;

    this.setAffCodeOptions();
  }

  private setAffCodeOptions() {
    let affCodeType = this.allAffCodeTypes.find((x) => x.AffCodeTypeID == this.affCodeTypeId);

    if (affCodeType) {
      this.affCodes = affCodeType.AffCodes.map((x) => {
        return { label: x.Descr, value: x.AffCode } as SelectItem;
      });
    }
  }
}
